// extracted by mini-css-extract-plugin
export var closeButton = "VideoModal-module--closeButton--fdd74";
export var videoModal = "VideoModal-module--videoModal--fe9c3";